// extracted by mini-css-extract-plugin
export var bgOverlay = "product-detail-masthead-module--bgOverlay--bb12e";
export var contentContainer = "product-detail-masthead-module--contentContainer--682c2";
export var headline = "product-detail-masthead-module--headline--9c0bb";
export var innerContent = "product-detail-masthead-module--innerContent--7f1bf";
export var innerContentContainer = "product-detail-masthead-module--innerContentContainer--a0da1";
export var picture = "product-detail-masthead-module--picture--6e0a7";
export var underImageBar = "product-detail-masthead-module--underImageBar--a6ad2";
export var wrapper = "product-detail-masthead-module--wrapper--1d7ec";